export default "__VITE_ASSET__CcoqHZFk__"